<template>
  <div class="bg">
    <img src="../assets/images/sb.png" alt="" />
    <div class="tit">认证失败</div>
    <div class="tit2">抱歉，您本次溯源认证失败，请重试</div>
  </div>
</template>
    
    <script>
export default {
  data() {
    return {};
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {},
};
</script>
    <style lang="scss" scoped>
.bg {
  padding-top: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 140px;
    height: 140px;
    margin: 0 auto;
  }
  .tit {
    margin-top: 28px;
    font-size: 44px;
    font-weight: bold;
  }
  .tit2 {
    margin-top: 10px;
    color: #8e8e8e;
    font-size: 32px;
  }
}
</style>
    